import "./table-row.scss";
import FontBody2 from "../../../fonts/font-body2/font-body2";
import { RadioButton } from "../../../inputs/radio-button/radio-button";

export interface ITableRowProps {
    cells: React.ReactNode[];
    colspan?: number;
    selectable?: boolean;
    onSelect?: () => void;
    selected?: boolean;
    name?: string;
    disabled?: boolean;
    skipWrapingCell?: boolean;
}

const TableRow: React.FC<ITableRowProps> = ({ cells, colspan = 1, selectable, selected, onSelect,  disabled = false, name = 'default', skipWrapingCell = false}) => {
    const inputName = `table-row-${name}`
    return (
        <div
            className={`table-row ${inputName}${selectable || onSelect ? ' table-row-selectable selectable' : ''}` + (disabled ? ' disabled' :'')}
            onClick={onSelect}
        >
            {selectable && <div className="table-row-item">
                <RadioButton name={inputName} checked={selected} />
            </div>}
            {cells.map((c, i) => <div className="table-row-item" key={i} style={{ gridColumn: `span ${colspan}` }}>
                <>
                    {skipWrapingCell
                        ? c
                        : <FontBody2>{c}</FontBody2>
                    }  
                </>              
            </div>)}
        </div>
    );
}
export default TableRow;
